import { useState, useEffect } from 'react';
import Select from 'react-select'
import { categoryLabels, mediaLabels, convertToUTC, convertTime12to24 } from '../constants';
import axios from 'axios';

export default function Form() {
    const [dateInput, setDateInput] = useState('');
    const [venue, setVenue] = useState('');
    const [categorySelected, setCategorySelected] = useState([]);
    const handleCategoryChange = (selected) => {
        setCategorySelected(selected);
    };
    const [mediumSelected, setMediumSelected] = useState([]);
    const handleMediumChange = (selected) => {
        setMediumSelected(selected);
    };

    const [venues, setVenues] = useState([]);
    const venuesUrl = "https://a-list-backend.onrender.com/venues/";
    const eventsUrl = "https://a-list-backend.onrender.com/events/";
    
    useEffect(() => {
        axios.get(venuesUrl)
        .then((response) => {
        setVenues(response.data);
    }, (error) => {
        console.log(error);
    });
    }, []);

    const [eventName, setEventName] = useState('');
    const [eventDescription, setEventDescription] = useState('');
    const [eventLink, setEventLink] = useState('');
    const [festivalAffiliation, setFestival] = useState('');
    const [ticketPriceMin, setTicketPriceMin] = useState(0);
    const [ticketPriceMax, setTicketPriceMax] = useState(0);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const handleChange = (setState) => (event) => {
        setState(event.target.value);
      };
    const [venueName, setVenueName] = useState('');
    const [venueType, setVenueType] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [venueState, setVenueState] = useState('');
    const [zip, setZip] = useState('');
    const [neighborhood, setNeighborhood] = useState('');
    const [venueWebsite, setVenueWebsite] = useState('');
    const [venueInsta, setVenueInsta] = useState('');
    const [accessibilityInfo, setAccessibilityInfo] = useState('');
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();

    const clearForm = () => {
        setDateInput('');
        setVenue('');
        setCategorySelected([]);
        setMediumSelected([]);
        setEventName('');
        setEventDescription('');
        setEventLink('');
        setTicketPriceMax(0);
        setTicketPriceMin(0);
        setStartTime('');
        setEndTime('');
        setVenueName('');
        setVenueType('');
        setAddress1('');
        setAddress2('');
        setCity('');
        setVenueState('');
        setZip('');
        setNeighborhood('');
        setVenueWebsite('');
        setVenueInsta('');
        setAccessibilityInfo('');
        setFestival('');
    }

    const getCoordinates = () => {
        const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
        const searchText = `${address1}%20${address2}%20${city}%20${venueState}%20${zip}`
        axios.get(`https://api.mapbox.com/search/geocode/v6/forward?q=${searchText}&access_token=${accessToken}`)
        .then((response) => {
            const coords = response?.data.features[0].properties.coordinates;
            setLatitude(coords.latitude);
            setLongitude(coords.longitude);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    const createNewEvent = () => {
        // make date input, start time, end time into date time strings 
        const timezoneOffset = -7; // For Pacific Standard Time (PST)
        const utcStartTime = convertToUTC(convertTime12to24(startTime), timezoneOffset);
        const utcEndTime = convertToUTC(convertTime12to24(endTime), timezoneOffset);
        const startDate = `${dateInput} ${utcStartTime}`;
        const endDate = `${dateInput} ${utcEndTime}`;
        const categoriesToPass = [];
        categorySelected.forEach((cat) => categoriesToPass.push(cat.value));
        const mediaToPass = [];
        mediumSelected.forEach((med) => mediaToPass.push(med.value));
        let formattedEventLink = eventLink;
        if (eventLink.slice(0,4) !== 'http') {
            formattedEventLink = `https://${eventLink}`
        } 
        const newEvent = {
            "name": eventName, 
            "description": eventDescription,
            "event_link": formattedEventLink,
            "start_time": startDate,
            "end_time": endDate,
            "ticket_price_min": Number(ticketPriceMin),
            "ticket_price_max": Number(ticketPriceMax),
            "venue_name": (venue !== 'new') ? venue : venueName,
            "categories": categoriesToPass,
            "mediums": mediaToPass, 
            "festival_affiliation": festivalAffiliation
        }
        console.log(newEvent);
        axios.post(eventsUrl, newEvent)
        .then((response) => {
            console.log(response);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        if (address1.length > 0 && city.length > 0 && venueState.length > 0 && zip.length > 0)
        getCoordinates();
    //eslint-disable-next-line
    }, [address1.length, city.length, venueState.length, zip.length])

    async function createNewVenue() {
        let formattedVenueLink = venueWebsite;
        if (venueWebsite.slice(0,4) !== 'http') {
            formattedVenueLink = `https://${venueWebsite}`
        } 
        const newVenue = {
            "name": venueName, 
            "type": venueType,
            "address_postal_code": zip,
            "address_city": city,
            "address_country": "USA",
            "address_state": venueState,
            "address_street": `${address1} ${address2}`,
            "accessibility_info": accessibilityInfo,
            "gps_latitude": latitude,
            "gps_longitude": longitude,
            "neighborhood": neighborhood,
            "website": formattedVenueLink,
            "instagram": venueInsta
        }
        console.log(newVenue);
        axios.post(venuesUrl, newVenue)
        .then((response) => {
            console.log(response);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const [errors, setErrors] = useState({});

    async function onSubmit() {
        const newErrors = {};
        if (!eventName) {
            newErrors.name = 'Title is required';
        }
        if (!dateInput) {
            newErrors.date = 'Date is required';
        }
        if (!eventLink) {
            newErrors.url = 'Event link is required';
        }
        if ((venue==='new' && !venueName) || (venue==='') || (venue==='choose')) {
            newErrors.venue = 'Please select or add a venue';
        }
        if (venue==='new' && !venueWebsite) {
            newErrors.venueWebsite = 'Venue website is required';
        }
        if (venue==='new' && !accessibilityInfo) {
            newErrors.acessibility = 'Venue acessibility information is required';
        }
        if (venue==='new' && !address1) {
            newErrors.address = 'Venue address is required';
        }
        if (venue==='new' && !city) {
            newErrors.city = 'Venue city is required';
        }
        if (venue==='new' && !venueState) {
            newErrors.state = 'Venue state is required';
        }
        if (venue==='new' && !zip) {
            newErrors.zip = 'Venue zip code is required';
        }
        if (venue==='new' && !venueType) {
            newErrors.type = 'Venue type is required';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            if (venue !== "new") {
                createNewEvent();
            }
            else {
                await createNewVenue();
                await axios.get(venuesUrl).then((response) => {
                    console.log(response);
                    createNewEvent()
                }, (error) => {
                    console.log(error);
                  });
            }
            clearForm();
        }
    };

    function showNewVenue() {
        if (venue === "new") {
            return (
                <div>
                    <div className="mb-3">
                    <div className="row mx-0">
                    <div className="col-md-7 col-lg-5 px-lg-2 col-xl-4 px-xl-0 px-xxl-3">
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Venue name</span>
                            <input name="name" type="text" className="form-control" placeholder="" value={venueName} onChange={handleChange(setVenueName)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Venue type</span>
                            <br/>{errors.type && <span className="error">{errors.type}</span>}
                            <select className="form-select" aria-label="Venue type select" onChange={handleChange(setVenueType)}>
                                <option default>Select venue type</option>
                                <option value="Arena">Arena</option>
                                <option value="Bar_Pub">Bar</option>
                                <option value="Cafe">Cafe</option>
                                <option value="ConcertHall">Concert hall</option>
                                <option value="Gallery">Gallery</option>
                                <option value="Library">Library</option>
                                <option value="Museum">Museum</option>
                                <option value="Nightclub">Nightclub</option>
                                <option value="Park">Park</option>
                                <option value="Restaurant">Restaurant</option>
                                <option value="Stadium">Stadium</option>
                                <option value="Street">Street</option>
                                <option value="Studio">Studio</option>
                                <option value="Theater">Theater</option>
                            </select>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Address line 1</span>
                            <br/>{errors.address && <span className="error">{errors.address}</span>}
                            <input name="address1" type="text" className="form-control" placeholder="" value={address1} onChange={handleChange(setAddress1)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Address line 2</span>
                            <input name="address2" type="text" className="form-control" placeholder="" value={address2} onChange={handleChange(setAddress2)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">City</span>
                            <br/>{errors.city && <span className="error">{errors.city}</span>}
                            <input name="city" type="text" className="form-control" placeholder="" value={city} onChange={handleChange(setCity)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">State</span>
                            <br/>{errors.state && <span className="error">{errors.state}</span>}
                            <input name="state" type="text" className="form-control" placeholder="" value={venueState} onChange={handleChange(setVenueState)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Zip code</span>
                            <br/>{errors.zip && <span className="error">{errors.zip}</span>}
                            <input name="zip" type="text" className="form-control" placeholder="" value={zip} onChange={handleChange(setZip)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Neighborhood</span>
                            <input name="neighborhood" type="text" className="form-control" placeholder="" value={neighborhood} onChange={handleChange(setNeighborhood)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Website</span>
                            <br/>{errors.venueWebsite && <span className="error">{errors.venueWebsite}</span>}
                            <input name="website" type="text" className="form-control" placeholder="" value={venueWebsite} onChange={handleChange(setVenueWebsite)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Instagram</span>
                            <input name="instagram" type="text" className="form-control" placeholder="" value={venueInsta} onChange={handleChange(setVenueInsta)}/>
                        </label>
                        <label className="d-block mb-4">
                            <span className="form-label d-block">Accessibility info</span>
                            <br/>{errors.accessibility && <span className="error">{errors.accessibility}</span>}
                            <textarea className="form-control" id="accessibility" rows="3" value={accessibilityInfo} onChange={handleChange(setAccessibilityInfo)}></textarea>
                        </label>
                        </div>
                    </div>
                    </div>
                </div>
            );
        }
    };
    
    return (
        <div className='container mb-5'>
             <form className="w-100 bg-white" action="">
            <div className="my-3">
                <label htmlFor="eventTitle" className="form-label">Event title</label>
                <br/>{errors.name && <span className="error">{errors.name}</span>}
                <input type="title" className="form-control" id="exampleFormControlInput1" placeholder="" value={eventName} onChange={handleChange(setEventName)}/>
            </div>
            <div className="my-3">
                <label className="form-label" htmlFor="eventTitle">Upload image</label>
                <br/><a href="https://docs.google.com/forms/d/e/1FAIpQLSfALExR9A99uqiMWpX9F3ob35H7ZD9-b9H3Y5s7K-eFHu9k1w/viewform?usp=sf_link"  target="_blank" rel="noreferrer">Click to upload your event image</a>
            </div>
            <div className="mb-3">
                <label htmlFor="festivalAffiliation" className="form-label">Festival or affiliation</label>
                <input type="festival" className="form-control" id="exampleFormControlInput1" placeholder="" value={festivalAffiliation} onChange={handleChange(setFestival)}/>
            </div>
            <div className="mb-3">
                <label htmlFor="venueSelect" className="form-label">Venue</label>
                <br/>{errors.venue && <span className="error">{errors.venue}</span>}
                <select className="form-select" aria-label="Venue selector" placeholder="" value={venue} onChange={handleChange(setVenue)}>
                    <option value="choose">Select venue</option>
                    {venues.map((venue) => {return (<option key={venue.id} value={venue.name}>{`${venue.name}`}</option>)})}
                    <option value="new">New venue</option>
                </select>
            </div>
            <div>
                {showNewVenue()}
            </div>
            <div className="mb-3">
                <label htmlFor="eventDate" className="form-label">Event date</label>
                <br/>{errors.date && <span className="error">{errors.date}</span>}
                <input id="eventDate" className="form-control" type="date" onChange={event => setDateInput(event.target.value)} value={dateInput}/>
            </div>
            <div className="mb-3">
                <label htmlFor="startTime" className="form-label">Start time</label>
                <input type="time" className="form-control" id="exampleFormControlInput1" placeholder="" value={startTime} onChange={handleChange(setStartTime)}/>
            </div>
            <div className="mb-3">
                <label htmlFor="endTime" className="form-label">End time</label>
                <input type="time" className="form-control" id="exampleFormControlInput1" placeholder="" value={endTime} onChange={handleChange(setEndTime)}/>
            </div>
            <div className="mb-3">
                <label htmlFor="eventDescription" className="form-label">Event description</label>
                <textarea className="form-control" id="eventDescription" rows="3" value={eventDescription} onChange={handleChange(setEventDescription)}></textarea>
            </div>
            <div className="mb-3">
                <label htmlFor="price" className="form-label">Minimum Price</label>
                <input type="price" className="form-control" id="exampleFormControlInput1" placeholder="" value={ticketPriceMin} onChange={handleChange(setTicketPriceMin)}/>
            </div>
            <div className="mb-3">
                <label htmlFor="price" className="form-label">Maximum Price</label>
                <input type="price" className="form-control" id="exampleFormControlInput1" placeholder="" value={ticketPriceMax} onChange={handleChange(setTicketPriceMax)}/>
            </div>
            <div className="row mb-3">
                    <div className="col">
                        <label htmlFor="category" className="form-label">Category</label>
                        <Select
                            isClearable={true}
                            closeMenuOnSelect={true}
                            isMulti
                            name="Category"
                            placeholder=""
                            options={categoryLabels}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={handleCategoryChange}
                            value={categorySelected}
                        />
                    </div>
                    <div className="col">
                        <label htmlFor="medium" className="form-label">Medium</label>
                        <Select
                            isClearable={true}
                            closeMenuOnSelect={true}
                            isMulti
                            name="Medium"
                            placeholder=""
                            options={mediaLabels}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={handleMediumChange}
                            value={mediumSelected}
                        />
                    </div>
            </div>
            <div className="mb-3">
                <label htmlFor="url" className="form-label">Event url</label>
                <br/>{errors.url && <span className="error">{errors.url}</span>}
                <input type="url" className="form-control" id="exampleFormControlInput1" placeholder="" value={eventLink} onChange={handleChange(setEventLink)}/>
            </div>
            <div className="row my-3 justify-content-end">
                <div className="col-1">
                    <button type="button" className="btn btn-dark" onClick={onSubmit}>Submit</button>
                </div>
            </div>
            </form>
        </div>
    );
}